import { GeoDsMeta } from "./meta-data.model";
import {Property} from './property.model';

export class MeasureProgress extends GeoDsMeta {
    ParentId: string;
    Progress: string;
    NextSteps: string;
    Decision: string;
    Opportunities: string;
    RiskAndChance: string;
    ProgressDate: Date;
    MaturityLevel: string;
    ProgressPercentage: number;
    Properties?: Property[]
    constructor(data) {
        super();
        Object.assign(this, data);
    }
}
